// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ch-cta {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding: 17px 18px;
  border-radius: var(--radius-lg);
  background: var(--grad-brand);
  color: #fff;
  text-decoration: none;
  box-shadow: var(--shadow-brand);
  transition: transform 0.15s;
}

.ch-cta:hover {
  transform: translateY(-2px);
}

.ch-cta-ico {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.18);
}

.ch-cta-txt strong {
  display: block;
  font-family: var(--font-display);
  font-size: 1.02rem;
  font-weight: 700;
}

.ch-cta-txt span {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
}

.ch-section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 13px;
}

.ch-section-link {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--brand);
  text-decoration: none;
}

.ch-section-link:hover {
  text-decoration: underline;
}

.ch-skel {
  height: 104px;
}
`, "",{"version":3,"sources":["webpack://./src/app/client/ClientHome.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ch-cta {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 20px;\n  padding: 17px 18px;\n  border-radius: var(--radius-lg);\n  background: var(--grad-brand);\n  color: #fff;\n  text-decoration: none;\n  box-shadow: var(--shadow-brand);\n  transition: transform 0.15s;\n}\n\n.ch-cta:hover {\n  transform: translateY(-2px);\n}\n\n.ch-cta-ico {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: var(--radius);\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.ch-cta-txt strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 1.02rem;\n  font-weight: 700;\n}\n\n.ch-cta-txt span {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.ch-section-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 13px;\n}\n\n.ch-section-link {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--brand);\n  text-decoration: none;\n}\n\n.ch-section-link:hover {\n  text-decoration: underline;\n}\n\n.ch-skel {\n  height: 104px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
